module.exports = __webpack_public_path__ + "img/modal-img-dark.e8e0f38a.png";